import React from 'react'
import { mfeConfigs } from '../../utilities/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import { useAuthToken } from '../../utilities/hooks/useAuthToken'
import { useDeviceAuthToken } from '../../utilities/hooks/useDeviceAuthToken'
import { CustomerSearch, MFERenderedPages } from '@getgreenline/customer-search'
import { IGlobalLocationContract } from '@getgreenline/locations/build/models'
import { IBaseLoyaltyTier } from '@getgreenline/homi-shared'
import { Dayjs } from 'dayjs'

interface IProps {
  companyId: number
  basename: string
  canAccessLoyalty: boolean
  canViewCustomerTotalSpend: boolean
  canEditCustomers: boolean
  parentPage?: MFERenderedPages
  actions: {
    onCustomerNameClick: (customer: CustomerSearch.API.GlobalCustomer) => void
    onDeleteCustomer: (customer: CustomerSearch.API.GlobalCustomer) => void
  }
  locations: IGlobalLocationContract[]
  loyaltyTiers?: IBaseLoyaltyTier[]
  handleGlobalCustomerCheck?: (globalCustomerIds: string[]) => void
  setDisplayedGlobalCustomers?: (customers: CustomerSearch.API.GlobalCustomer[]) => void
  setDisplayedColumns?: (columns: string[]) => void
  setGlobalPagination?: (pagination: CustomerSearch.API.Pagination) => void
  isWebPOS?: boolean
  setDisplayedLastPurchaseDateRange?: (range: [Dayjs | null, Dayjs | null]) => void
  selectedGlobalCustomers?: CustomerSearch.API.GlobalCustomer[]
  componentHeight?: string
}

export const CustomersPageMFE: React.FC<IProps> = ({
  companyId,
  basename,
  actions,
  canAccessLoyalty = false,
  canViewCustomerTotalSpend = false,
  canEditCustomers = false,
  locations,
  loyaltyTiers,
  setDisplayedGlobalCustomers,
  setDisplayedColumns,
  handleGlobalCustomerCheck,
  setGlobalPagination,
  parentPage = MFERenderedPages.CUSTOMER_SEARCH,
  isWebPOS = false,
  setDisplayedLastPurchaseDateRange,
  selectedGlobalCustomers = [],
  componentHeight,
}) => {
  const token = isWebPOS ? useDeviceAuthToken() : useAuthToken()

  return token ? (
    <SingleSpaParcel
      basename={basename}
      authToken={token}
      canAccessLoyalty={canAccessLoyalty}
      canViewCustomerTotalSpend={canViewCustomerTotalSpend}
      canEditCustomers={canEditCustomers}
      merchantId={`blc-${companyId}`}
      setDisplayedGlobalCustomers={setDisplayedGlobalCustomers}
      setGlobalPagination={setGlobalPagination}
      platform={'pos'}
      actions={actions}
      handleGlobalCustomerCheck={handleGlobalCustomerCheck}
      config={mfeConfigs.LOAD_CUSTOMERS_PAGE}
      selectedGlobalCustomers={selectedGlobalCustomers}
      wrapStyle={{
        height: componentHeight,
        display: 'flex',
        flexDirection: 'column',
      }}
      locations={locations}
      loyaltyTiers={loyaltyTiers}
      parentPage={parentPage}
      setDisplayedColumns={setDisplayedColumns}
      setDisplayedLastPurchaseDateRange={setDisplayedLastPurchaseDateRange}
    />
  ) : (
    <></>
  )
}
